import React from "react";

import { cn } from "@/utils/shadcn-ui";

export function FormGrid({
  children,
  columns = 2,
  className,
}: {
  children?: React.ReactNode;
  columns?: number;
  className?: string;
}) {
  return (
    <div
      className={cn("grid gap-x-6 gap-y-4", className)}
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {children}
    </div>
  );
}
